var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMontatura2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets/Glyphs/Product/Technology@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets/Glyphs/Product/Technology",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9007009,13 C16.8866988,13 18.5,14.2647113 18.5,16.7135537 C18.5,20.5605105 13.0323331,27 9.05581009,27 C5.03785715,27 3,23.9245702 3,19.0506836 C3,15.432297 6.03880438,13.2033577 9.17694366,13.0120738 L9.39600781,13.0020427 L9.53063851,13 L13.9007009,13 Z M29.9693615,13 C33.1613037,13 36.5,15.2790507 36.5,19.0506836 C36.5,22.1880647 35.6518196,24.6182095 33.9107748,25.9327498 L33.7136488,26.0741981 L33.5901455,26.1583455 L27.7905039,26.2581891 L27.6738723,26.1939776 C24.3378466,24.3573272 21,19.5573164 21,16.7135537 C21,14.3389187 22.5170068,13.0777365 25.3316329,13.0034818 L25.5992991,13 L29.9693615,13 Z M9.53845049,13.999939 L9.41912754,14.0017473 C6.69092021,14.0853119 4,15.9862592 4,19.0506836 C4,23.4380505 5.69761221,26 9.05581009,26 C12.4404678,26 17.5,20.0411871 17.5,16.7135537 C17.5,14.9388543 16.4538289,14.0595752 14.1441494,14.0029285 L13.9007009,13.999939 L9.53845049,13.999939 Z M29.9693615,14 L25.5992991,14 C23.1195648,14 22,14.8776578 22,16.7135537 C22,19.0968019 24.9563012,23.410846 27.9162183,25.1801714 L28.046,25.254 L33.265,25.164 L33.3197049,25.1258232 C34.6456269,24.115 35.3792639,22.2256179 35.4863065,19.7078826 L35.4967123,19.3759394 L35.5,19.0506836 C35.5,16.0083668 32.8117468,14.0972617 30.1722569,14.0036079 L29.9693615,14 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "#000000",
    fillRule: "nonzero",
    points: "13.9766355 13 26.0233645 13 26.0233645 14 13.9766355 14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3-Copy",
    fill: "#000000",
    fillRule: "nonzero",
    points: "18 16.5 22 16.5 22 17.5 18 17.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,23 L32.7633558,26.572949 L36.7063391,27.145898 L33.8531695,29.927051 L34.5267115,33.854102 L31,32 L27.4732885,33.854102 L28.1468305,29.927051 L25.2936609,27.145898 L29.2366442,26.572949 L31,23 Z M32.0992902,27.4869568 L31,25.259 L29.9007098,27.4869568 L27.442,27.844 L29.221311,29.5779311 L28.801,32.025 L31,30.8702243 L33.198,32.025 L32.778689,29.5779311 L34.557,27.844 L32.0992902,27.4869568 Z",
    id: "Star",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMontatura2);
export default __webpack_public_path__ + "static/media/montatura2.6f26e8e3f0205d66e7b1056d0581438f.svg";
export { ForwardRef as ReactComponent };